<div class="banner">
  <div class="question-container">
    <div class="question">Buying a home?</div>
    <div class="answer">Get in touch with one of our pressure-free, salaried agents</div>
  </div>
  <div class="p-2 align-self-center flex-shrink-0">
    <a
      #link
      class="get-started btn btn-primary"
      [routerLink]="['/questionnaire/buy/1']"
      [queryParams]="listingTimeline ? { referringListing: listingTimeline.id } : {}"
    >
      Get Started
    </a>
  </div>
</div>
